module.exports = __webpack_public_path__ + "static/G-Mart-955-Garden-Hwy-Yuba-City-CA-95991-9444883e51567e8ba0d3de217587e8d9.jpg";